import { cn } from '../../lib/cn';
import { RoundButton } from './Button';
import styles from './Carousel.module.css';

/**
 * Scroll-snap track. No carousel library: native scrolling gives momentum,
 * swipe and keyboard support that a JS implementation only approximates, and
 * the whole thing still works if the bundle fails to load.
 */
export function CarouselTrack({ trackRef, bleed = false, itemWidth, gap, className, children, ...rest }) {
  return (
    <div
      ref={trackRef}
      className={cn(styles.track, bleed && 'bleed', className)}
      style={{
        '--carousel-item': itemWidth,
        '--carousel-gap': gap,
      }}
      // Announce changes politely; the cards themselves stay in the tab order.
      role="group"
      aria-roledescription="carousel"
      {...rest}
    >
      {children}
    </div>
  );
}

/** Prev/next pair, disabled at the ends. Hidden on touch via CSS. */
export function CarouselArrows({ prev, next, atStart, atEnd, label = 'items', className }) {
  return (
    <div className={cn(styles.arrows, className)} style={{ display: 'flex', gap: 'var(--space-4)' }}>
      <RoundButton
        icon="arrow-left"
        variant="outline"
        label={`Previous ${label}`}
        onClick={prev}
        disabled={atStart}
      />
      <RoundButton
        icon="arrow-right"
        variant="primary"
        label={`Next ${label}`}
        onClick={next}
        disabled={atEnd}
      />
    </div>
  );
}

export function CarouselDots({ count, index, goTo, label = 'item' }) {
  if (count < 2) return null;
  return (
    <div className={styles.dots}>
      {Array.from({ length: count }, (_, i) => (
        <button
          key={i}
          type="button"
          className={cn(styles.dot, i === index && styles.dotActive)}
          aria-label={`Go to ${label} ${i + 1}`}
          aria-current={i === index || undefined}
          onClick={() => goTo(i)}
        />
      ))}
    </div>
  );
}
